import './Styles/App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Layout from "./pages/Layout"
import Home from "./pages/Home"
import ProjectOverview from "./pages/ProjectOverview"
import ScrollToTop from './ScrollToTop';
import About from './pages/About';
import Project from './pages/Project';

function App() {
  return (
    <div className="App mx-auto h-screen">
      <BrowserRouter>
      <ScrollToTop />
      <AnimatePresence mode="wait">
      <Routes>
        <Route path="/" element={<Layout/>}>
          <Route index element={<Home />} />
          <Route path="projects/:projectName" element={<Project />}/>
        </Route>
        <Route path='/About' element={<About/>}></Route>
        <Route path='/Allprojects' element={<ProjectOverview/>}></Route>
      </Routes>
      </AnimatePresence>
      </BrowserRouter>
      
    </div>
    
  );
}

export default App;
